import { useEffect } from 'react';
import { toast } from 'sonner';
import { useNavigate } from 'react-router-dom';

/**
 * Listens for `app:upgrade-required` events (dispatched by axios on 402)
 * and shows a friendly toast with a "See plans" action.
 */
export default function UpgradeListener() {
    const navigate = useNavigate();

    useEffect(() => {
        const handler = (e) => {
            const { kind, used, limit, message } = e.detail || {};
            toast.error(message || 'Upgrade required to keep going.', {
                duration: 8000,
                action: {
                    label: 'See plans',
                    onClick: () => navigate('/pricing'),
                },
                description: kind && limit
                    ? `You've used ${used}/${limit} ${kind} this week.`
                    : undefined,
            });
        };
        window.addEventListener('app:upgrade-required', handler);
        return () => window.removeEventListener('app:upgrade-required', handler);
    }, [navigate]);

    return null;
}
